import React from 'react';
import Logo from '../../assets/logo-text.svg?react';

const LogoIcon = (props) => {
  return <Logo {...props} />;
};

export default LogoIcon;
